// extracted by mini-css-extract-plugin
var _1 = "DocFlowSendingEmailContent-modulenoSettings__whUbF DocFlowSendingWidgetContent-moduleDocFlowSendingWidgetContent__dZXYj";
export { _1 as "noSettings" }
